interface ErrorViewProps {
  /** The thrown error; its message is shown in development builds. */
  error?: Error;
  /** Resets the error boundary and retries rendering. */
  reset: () => void;
}

export default function ErrorView({ error, reset }: ErrorViewProps): JSX.Element {
  return (
    <div className="view" style={{ textAlign: 'center', padding: '96px 24px' }}>
      <div className="section-header" style={{ marginBottom: 12 }}>
        Something Went Wrong
      </div>
      <div className="gold-divider">
        <span className="divider-gem">◆</span>
      </div>
      <p
        style={{
          color: 'var(--text-muted)',
          fontFamily: 'var(--cormorant)',
          fontSize: 18,
          marginBottom: 28,
        }}
      >
        {process.env.NODE_ENV === 'development'
          ? error?.message || 'An unexpected error occurred.'
          : 'An unexpected error occurred. Please try again.'}
      </p>
      <button type="button" className="btn-gold" style={{ padding: '12px 28px' }} onClick={reset}>
        Try Again
      </button>
    </div>
  );
}
